import Polyglot from 'node-polyglot';

import de from '../../../config/i18n/de.all.json';
import en from '../../../config/i18n/en.all.json';
import es from '../../../config/i18n/es.all.json';
import fr from '../../../config/i18n/fr.all.json';
import it from '../../../config/i18n/it.all.json';
import ja from '../../../config/i18n/ja.all.json';
import ko from '../../../config/i18n/ko.all.json';
import pt from '../../../config/i18n/pt.all.json';
import zhHans from '../../../config/i18n/zh-Hans.all.json';
import zhHant from '../../../config/i18n/zh-Hant.all.json';


const translationMap = {
  'de': de,
  'en': en,
  'es': es,
  'fr': fr,
  'it': it,
  'ja': ja,
  'ko': ko,
  'pt': pt,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};

export const translationSupportedLanguages = [
  'de',
  'en',
  'es',
  'fr',
  'it',
  'ja',
  'ko',
  'pt',
  'zh-Hans',
  'zh-Hant'
];

export default class {
  constructor(l, tns) {
    const tMap = tns ? tns : translationMap;
    let allowMissing = false;
    let onMissingKey = null;
    let locale = 'en';

    if (document.documentElement.lang && tMap.hasOwnProperty(document.documentElement.lang)) {
      locale = document.documentElement.lang;
    }
    if (l && tMap.hasOwnProperty(l)) {
      locale = l;
    }

    if (locale !== 'en') {
      this.pEn = new Polyglot({
        locale: 'en',
        phrases: this.transformPhrases(tMap['en']),
        interpolation: {prefix: '{{.', suffix: '}}'}
      });

      allowMissing = true;
      onMissingKey = (key, options, locale) => {
        return this.pEn.t(key, options);
      }
    }

    this.p = new Polyglot({
      locale: locale,
      phrases: this.transformPhrases(tMap[locale]),
      allowMissing: allowMissing,
      onMissingKey: onMissingKey,
      interpolation: {prefix: '{{.', suffix: '}}'}
    });
  }

  transformPhrases(tns) {
    const keys = {};

    tns.forEach((translation) => {
      let t = translation["translation"];
      if (typeof t === 'object') {
        t = Object.values(t).join(' |||| ');
        t = t.replace(/.Count/gm, '.smart_count');
      }

      keys[translation["id"]] = t;
    });

    return keys;
  }

  t(key, opts) {
    opts = opts ? opts : {};
    return this.p.t(key, opts);
  }
}
